export const Users = [
  {
    id:1,
    profilePicture: "person/1.jpg",
    username: "Naruto",
  },
  {
    id:2,
    profilePicture: "person/2.jpg",
    username: "Itachi",
  },
  {
    id:3,
    profilePicture: "person/3.png",
    username: "Jhon Cena",
  },
  {
    id:4,
    profilePicture: "person/4.jpg",
    username: "Rock",
  },
  {
    id:5,
    profilePicture: "person/5.jpg",
    username: "Cm Punk",
  },
  {
    id:6,
    profilePicture: "person/6.jpg",
    username: "Ironman",
  },
  {
    id:7,
    profilePicture: "person/7.jpg",
    username: "Spiderman",
  },
  {
    id:8,
    profilePicture: "person/8.jpg",
    username: "Batman",
  }
];

export const Posts = [
  {
    id: 1,
    desc: "Love For All, Hatred For None.",
    photo: "post/1.jpeg",
    date: "5 mins ago",
    userId: 1,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    photo: "post/2.jpeg",
    date: "15 mins ago",
    userId: 2,
    like: 2,
    comment: 1,
  },
  {
    id: 3,
    desc: "Every moment is a fresh beginning.",
    photo: "post/3.jpeg",
    date: "1 hour ago",
    userId: 3,
    like: 61,
    comment: 2,
  },
  {
    id: 4,
    photo: "post/4.jpeg",
    date: "4 hours ago",
    userId: 4,
    like: 7,
    comment: 3,
  },
  {
    id: 5,
    photo: "post/5.jpeg",
    date: "5 hours ago",
    userId: 5,
    like: 23,
    comment: 5,
  },
  {
    id: 6,
    photo: "post/6.jpeg",
    date: "1 day ago",
    userId: 6,
    like: 44,
    comment: 6,
  },
  {
    id: 7,
    desc: "Never regret anything that made you smile.",
    photo: "post/7.jpeg",
    date: "2 days ago",
    userId: 7,
    like: 52,
    comment: 3,
  },
  {
    id: 8,
    photo: "post/8.jpeg",
    date: "3 days ago",
    userId: 8,
    like: 15,
    comment: 1,
  },
  {
    id: 9,
    desc: "Change the world by being yourself.",
    photo: "post/9.jpeg",
    date: "5 days ago",
    userId: 9,
    like: 11,
    comment: 2,
  },
  {
    id: 10,
    photo: "post/10.jpeg",
    date: "1 week ago",
    userId: 10,
    like: 104,
    comment: 12,
  },
];